/* eslint-disable react/no-children-prop */
import { themeStore } from "@/stores/theme";
import { Text, Input, InputGroup, InputGroupProps, InputRightElement } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { FC, useCallback, useEffect, useState } from "react";
import uiConfig from "../config";
interface VerificationCodeInputProps {
  // 验证码值
  value: string;
  // 验证码长度
  length: number;
  // 倒计时
  defaultCoolingTime?: number;
  // 提示
  placeholder?: string;
  // 上次获取验证码的时间戳，防止刷新反复获取验证码
  prevGetCodeTimestamp?: string | null;
  // 当输入验证码
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  // 当计时改变
  onTimeCounting?: (time: number) => void;
  // 当用户点击获取验证码
  onGetCode?: () => boolean;
  // 发送按钮文本获取(主要是为了国际化而且可复用)
  btnText: (time: number) => string;
}

const VerificationCodeInput: FC<VerificationCodeInputProps & InputGroupProps> = (props) => {
  const {
    value,
    length,
    placeholder,
    defaultCoolingTime = 60,
    onChange,
    onGetCode,
    onTimeCounting,
    prevGetCodeTimestamp,
    btnText,
  } = props;
  const [timer, setTimer] = useState<number | null>(null);
  const [time, setTime] = useState(0);
  const { loginBtnColor } = themeStore.styles;

  const onValueChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { value: v } = e.target;
    const reg = RegExp(`^[0-9]{0,${length}}$`);
    if (reg.test(v)) onChange(e);
  };

  const handlerGetCode = () => {
    if (onGetCode) if (!onGetCode()) return;

    startCounting();
  };

  const startCounting = useCallback(() => {
    setTime(defaultCoolingTime);
  }, [time, timer]);

  useEffect(
    () => () => {
      if (timer) clearInterval(timer);
    },
    [timer],
  );

  useEffect(() => {
    if (time > 0) {
      setTimer(
        window.setTimeout(() => {
          setTime(() => {
            const crtTime = time - 1;
            onTimeCounting?.(crtTime);
            return crtTime;
          });
        }, 1000),
      );
    }
  }, [time]);

  useEffect(() => {
    if (prevGetCodeTimestamp) {
      const now = new Date().getTime();
      const long = Math.floor((now - parseInt(prevGetCodeTimestamp)) / 1000);
      if (long < defaultCoolingTime) setTime(defaultCoolingTime - long);
    }
  }, []);

  return (
    <InputGroup {...props}>
      <Input
        type="number"
        fontSize={uiConfig.inputFontSize}
        value={value}
        onChange={onValueChange}
        maxLength={length}
        borderColor="fill.emphasis"
        _focusVisible={{
          borderColor: loginBtnColor,
        }}
        color="inherit"
        placeholder={placeholder}
        _placeholder={{ color: "#C9CDD4", fontSize: uiConfig.inputFontSize }}
      />
      <InputRightElement w="42%" paddingRight="10px" justifyContent="flex-end">
        <Text
          cursor="pointer"
          fontSize={uiConfig.inputFontSize}
          onClick={handlerGetCode}
          color={time > 0 ? "#C9CDD4" : "#36c19e"}
        >
          {btnText(time)}
        </Text>
      </InputRightElement>
    </InputGroup>
  );
};

export default observer(VerificationCodeInput);
